import { render, staticRenderFns } from "./ChronicDiseases.vue?vue&type=template&id=5c894099&scoped=true"
import script from "./ChronicDiseases.vue?vue&type=script&lang=js"
export * from "./ChronicDiseases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c894099",
  null
  
)

export default component.exports